export default "assets/images/icons/simulation-0b5251c1.svg";